import { InternalReportKey, RELATIONSHIP_KEY } from './../model/score-card.model';
import { ScoreCardService } from './../service/score-card.service';
import { Component, Inject, OnInit } from '@angular/core';
import d3 from 'd3';
import { RadarChart } from './spider-chart';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-spider-chart',
  templateUrl: './spider-chart.component.html',
  styleUrls: ['./spider-chart.component.scss']
})
export class SpiderChartComponent implements OnInit {

  dataChart: any[];
  constructor(
    private scorecardService: ScoreCardService,
    private dialogRef: MatDialogRef<SpiderChartComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any[],
  ) {
    this.dialogRef.disableClose = true;
    this.dataChart = this.buildArrayData(this.data);

   }

  ngOnInit() {
    this.dataChart.forEach((item, index) => {
      setTimeout(() => {
        const chart = new RadarChart();
        chart.draw('#chart' + index, item);
      }, 1000);
    });
  }

  public buildArrayData(data) {
    const spiderData = data.map(item => {
      const spider = Object.keys(item).map(kpi => {
        if (InternalReportKey[kpi] || RELATIONSHIP_KEY[kpi]) {
          const name = InternalReportKey[kpi] ? InternalReportKey[kpi] : RELATIONSHIP_KEY[kpi];
          const object = {
            axis: kpi,
            value: item[name].p,
            label: item[name].avg + ' Avg; Max ' + item[name].max,
            color: item[name].clr
          };
          return object;
        }
      });
      return [spider.filter(k => k)];
    });
    return spiderData;
  }

}
